
export class ClearPlanGoodsChangeManageRequestModel {

  public orderCode: string = <string>'';
  public pCode: string = <string>'';
  public mode: string = <string>'';
}
